import { Vector3, ParticleSystem, Color4, Color3, MeshBuilder, StandardMaterial, Mesh, DynamicTexture, ShaderMaterial, Effect, PointLight, } from '@babylonjs/core';
// ========== 注册自定义 Shader ==========
// 剑气刀光 shader（扫光流动效果）
Effect.ShadersStore['swordQiVertexShader'] = `
  precision highp float;
  attribute vec3 position;
  attribute vec2 uv;
  uniform mat4 worldViewProjection;
  varying vec2 vUV;
  void main() {
    vUV = uv;
    gl_Position = worldViewProjection * vec4(position, 1.0);
  }
`;
Effect.ShadersStore['swordQiFragmentShader'] = `
  precision highp float;
  varying vec2 vUV;
  uniform float time;
  uniform vec3 baseColor;
  uniform float alpha;
  void main() {
    float wave = sin(vUV.x * 12.0 - time * 8.0) * 0.5 + 0.5;
    float edge = smoothstep(0.0, 0.15, vUV.y) * smoothstep(1.0, 0.6, vUV.y);
    float trail = smoothstep(0.0, 0.3, vUV.x) * smoothstep(1.0, 0.5, vUV.x);
    float glow = edge * trail * (0.6 + 0.4 * wave);
    vec3 col = baseColor + vec3(0.3, 0.3, 0.4) * wave;
    gl_FragColor = vec4(col, glow * alpha);
  }
`;
// AOE 地面法阵 shader（旋转符文光圈）
Effect.ShadersStore['magicCircleVertexShader'] = `
  precision highp float;
  attribute vec3 position;
  attribute vec2 uv;
  uniform mat4 worldViewProjection;
  varying vec2 vUV;
  void main() {
    vUV = uv;
    gl_Position = worldViewProjection * vec4(position, 1.0);
  }
`;
Effect.ShadersStore['magicCircleFragmentShader'] = `
  precision highp float;
  varying vec2 vUV;
  uniform float time;
  uniform vec3 baseColor;
  uniform float alpha;
  void main() {
    vec2 center = vUV - 0.5;
    float dist = length(center);
    float angle = atan(center.y, center.x);
    // 多层同心环
    float ring1 = smoothstep(0.38, 0.40, dist) * smoothstep(0.44, 0.42, dist);
    float ring2 = smoothstep(0.28, 0.30, dist) * smoothstep(0.34, 0.32, dist);
    float ring3 = smoothstep(0.15, 0.17, dist) * smoothstep(0.21, 0.19, dist);
    // 旋转符文线条
    float rune = sin(angle * 6.0 + time * 3.0) * 0.5 + 0.5;
    rune *= smoothstep(0.45, 0.30, dist) * smoothstep(0.10, 0.25, dist);
    // 外圈渐隐
    float outer = smoothstep(0.50, 0.45, dist);
    float inner = (ring1 + ring2 * 0.7 + ring3 * 0.5 + rune * 0.4) * outer;
    // 呼吸脉动
    float pulse = 0.8 + 0.2 * sin(time * 4.0);
    gl_FragColor = vec4(baseColor * (1.0 + inner * 0.5), inner * alpha * pulse);
  }
`;
// 能量球/冲击波 shader
Effect.ShadersStore['energyBallVertexShader'] = `
  precision highp float;
  attribute vec3 position;
  attribute vec3 normal;
  attribute vec2 uv;
  uniform mat4 worldViewProjection;
  uniform float time;
  varying vec2 vUV;
  varying vec3 vNormal;
  void main() {
    vUV = uv;
    vNormal = normal;
    vec3 pos = position;
    pos += normal * 0.05 * sin(time * 10.0 + position.y * 5.0);
    gl_Position = worldViewProjection * vec4(pos, 1.0);
  }
`;
Effect.ShadersStore['energyBallFragmentShader'] = `
  precision highp float;
  varying vec2 vUV;
  varying vec3 vNormal;
  uniform float time;
  uniform vec3 baseColor;
  uniform float alpha;
  void main() {
    float fresnel = pow(1.0 - abs(dot(vNormal, vec3(0.0, 0.0, 1.0))), 2.0);
    float noise = sin(vUV.x * 20.0 + time * 5.0) * sin(vUV.y * 20.0 - time * 3.0);
    float pattern = 0.5 + 0.5 * noise;
    vec3 col = baseColor * (1.0 + fresnel * 0.8) + vec3(1.0) * fresnel * 0.3;
    float a = (0.4 + fresnel * 0.6) * alpha * (0.7 + 0.3 * pattern);
    gl_FragColor = vec4(col, a);
  }
`;
// 雷电闪电 shader
Effect.ShadersStore['lightningVertexShader'] = `
  precision highp float;
  attribute vec3 position;
  attribute vec2 uv;
  uniform mat4 worldViewProjection;
  uniform float time;
  varying vec2 vUV;
  void main() {
    vUV = uv;
    vec3 pos = position;
    pos.x += sin(position.y * 8.0 + time * 20.0) * 0.15;
    pos.z += cos(position.y * 6.0 + time * 15.0) * 0.1;
    gl_Position = worldViewProjection * vec4(pos, 1.0);
  }
`;
Effect.ShadersStore['lightningFragmentShader'] = `
  precision highp float;
  varying vec2 vUV;
  uniform float time;
  uniform vec3 baseColor;
  uniform float alpha;
  void main() {
    float core = smoothstep(0.5, 0.0, abs(vUV.x - 0.5));
    float flicker = 0.7 + 0.3 * sin(time * 30.0 + vUV.y * 10.0);
    vec3 col = baseColor + vec3(0.5, 0.5, 0.6) * core;
    gl_FragColor = vec4(col, core * alpha * flicker);
  }
`;
export class SkillEffects {
    scene;
    particleTex;
    sparkTex;
    smokeTex;
    constructor(scene) {
        this.scene = scene;
        this.particleTex = this.createGlowTexture(64);
        this.sparkTex = this.createSparkTexture(64);
        this.smokeTex = this.createSmokeTexture(64);
    }
    // ===== 程序化纹理生成 =====
    createGlowTexture(size) {
        const dt = new DynamicTexture('glowTex', size, this.scene, false);
        const ctx = dt.getContext();
        const grad = ctx.createRadialGradient(size / 2, size / 2, 0, size / 2, size / 2, size / 2);
        grad.addColorStop(0, 'rgba(255,255,255,1)');
        grad.addColorStop(0.2, 'rgba(255,255,255,0.9)');
        grad.addColorStop(0.5, 'rgba(255,255,255,0.3)');
        grad.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, size, size);
        dt.update();
        dt.hasAlpha = true;
        return dt;
    }
    createSparkTexture(size) {
        const dt = new DynamicTexture('sparkTex', size, this.scene, false);
        const ctx = dt.getContext();
        // 星芒形状
        const c = size / 2;
        const grad = ctx.createRadialGradient(c, c, 0, c, c, c);
        grad.addColorStop(0, 'rgba(255,255,255,1)');
        grad.addColorStop(0.1, 'rgba(255,255,255,0.8)');
        grad.addColorStop(0.4, 'rgba(255,255,255,0)');
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, size, size);
        // 十字光芒
        ctx.strokeStyle = 'rgba(255,255,255,0.6)';
        ctx.lineWidth = 2;
        ctx.beginPath();
        ctx.moveTo(c, 0);
        ctx.lineTo(c, size);
        ctx.moveTo(0, c);
        ctx.lineTo(size, c);
        ctx.stroke();
        dt.update();
        dt.hasAlpha = true;
        return dt;
    }
    createSmokeTexture(size) {
        const dt = new DynamicTexture('smokeTex', size, this.scene, false);
        const ctx = dt.getContext();
        // 柔和烟雾
        for (let i = 0; i < 5; i++) {
            const x = size / 2 + (Math.random() - 0.5) * size * 0.3;
            const y = size / 2 + (Math.random() - 0.5) * size * 0.3;
            const r = size * (0.2 + Math.random() * 0.2);
            const grad = ctx.createRadialGradient(x, y, 0, x, y, r);
            grad.addColorStop(0, 'rgba(255,255,255,0.3)');
            grad.addColorStop(1, 'rgba(255,255,255,0)');
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, size, size);
        }
        dt.update();
        dt.hasAlpha = true;
        return dt;
    }
    // ===== 门派颜色 =====
    getColors(faction) {
        switch (faction) {
            case 'sword': return {
                main: new Color3(0.2, 0.5, 1.0),
                bright: new Color3(0.6, 0.85, 1.0),
                c1: new Color4(0.4, 0.7, 1, 1),
                c2: new Color4(0.1, 0.3, 0.9, 0.6),
                dead: new Color4(0.1, 0.2, 0.5, 0),
            };
            case 'dao': return {
                main: new Color3(0.6, 0.2, 0.9),
                bright: new Color3(0.9, 0.5, 1.0),
                c1: new Color4(0.8, 0.3, 1, 1),
                c2: new Color4(0.5, 0.1, 0.7, 0.6),
                dead: new Color4(0.3, 0.05, 0.4, 0),
            };
            case 'monk': return {
                main: new Color3(1.0, 0.7, 0.1),
                bright: new Color3(1.0, 0.9, 0.5),
                c1: new Color4(1, 0.85, 0.3, 1),
                c2: new Color4(1, 0.6, 0.1, 0.5),
                dead: new Color4(0.5, 0.3, 0, 0),
            };
            case 'shadow': return {
                main: new Color3(0.1, 0.7, 0.3),
                bright: new Color3(0.3, 1.0, 0.5),
                c1: new Color4(0.2, 0.9, 0.4, 1),
                c2: new Color4(0.1, 0.5, 0.2, 0.5),
                dead: new Color4(0.05, 0.3, 0.1, 0),
            };
            default: return {
                main: Color3.White(),
                bright: Color3.White(),
                c1: new Color4(1, 1, 1, 1),
                c2: new Color4(0.5, 0.5, 0.5, 0.5),
                dead: new Color4(0, 0, 0, 0),
            };
        }
    }
    // ===== 主入口 =====
    playSkillEffect(skill, position, direction) {
        switch (skill.faction) {
            case 'sword':
                this.playSwordEffect(skill, position, direction);
                break;
            case 'dao':
                this.playDaoEffect(skill, position, direction);
                break;
            case 'monk':
                this.playMonkEffect(skill, position, direction);
                break;
            case 'shadow':
                this.playShadowEffect(skill, position, direction);
                break;
        }
    }
    // ==================== 剑宗技能特效 ====================
    playSwordEffect(skill, pos, dir) {
        const c = this.getColors('sword');
        switch (skill.id) {
            case 'sword_basic':
                this.effectSwordSlash(pos, dir, c);
                break;
            case 'sword_dash':
                this.effectSwordDash(pos, dir, c);
                break;
            case 'sword_storm':
                this.effectSwordStorm(pos, c);
                break;
            case 'sword_beam':
                this.effectSwordBeam(pos, dir, c);
                break;
            case 'sword_ult':
                this.effectSwordUlt(pos, c);
                break;
            case 'sword_shield':
                this.effectSwordShield(pos, c);
                break;
        }
    }
    // 破风斩 — 弧形剑气挥砍
    effectSwordSlash(pos, dir, c = this.getColors('sword')) {
        // 剑光弧线
        const arc = this.createSwordQiArc(pos, c.main, 2.0);
        if (dir)
            arc.rotation.y = Math.atan2(dir.x, dir.z);
        // 快速粒子爆发
        this.burstParticles(pos.add(new Vector3(0, 1, 0)), {
            tex: this.sparkTex,
            c1: c.c1, c2: c.c2, dead: c.dead,
            count: 40, life: 0.4, size: [0.05, 0.15],
            speed: [6, 12], gravity: -1, blend: 'add',
        });
        // 短闪光
        this.flashLight(pos, c.bright, 0.3, 3);
    }
    // 惊鸿掠影 — 闪身拖影
    effectSwordDash(pos, dir, c = this.getColors('sword')) {
        // 残影效果（3个逐渐消失的半透明身影）
        for (let i = 0; i < 3; i++) {
            const offset = dir ? dir.scale(-i * 1.5) : new Vector3(-i * 1.5, 0, 0);
            const ghost = MeshBuilder.CreateCylinder(`ghost${i}`, {
                height: 1.8, diameter: 0.6, tessellation: 8
            }, this.scene);
            ghost.position = pos.add(offset);
            ghost.position.y += 0.9;
            const mat = new StandardMaterial(`ghostMat${i}`, this.scene);
            mat.emissiveColor = c.bright;
            mat.disableLighting = true;
            mat.alpha = 0.5 - i * 0.15;
            mat.backFaceCulling = false;
            ghost.material = mat;
            this.fadeAndDispose(ghost, mat, 0.6 + i * 0.15);
        }
        // 移动轨迹粒子
        this.trailParticles(pos, dir || Vector3.Forward(), 10, {
            tex: this.particleTex,
            c1: c.c1, c2: c.c2, dead: c.dead,
            count: 80, life: 0.6, size: [0.08, 0.2],
            speed: [1, 3], gravity: 0, blend: 'add',
        });
        this.flashLight(pos, c.bright, 0.2, 4);
    }
    // 万剑归宗 — 剑气环绕旋转
    effectSwordStorm(pos, c = this.getColors('sword')) {
        // 旋转剑气环
        const swordCount = 8;
        const swords = [];
        for (let i = 0; i < swordCount; i++) {
            const sword = MeshBuilder.CreateBox(`stormSword${i}`, {
                width: 0.08, height: 1.2, depth: 0.02
            }, this.scene);
            const mat = new StandardMaterial(`stormMat${i}`, this.scene);
            mat.emissiveColor = c.bright;
            mat.disableLighting = true;
            mat.alpha = 0.8;
            mat.backFaceCulling = false;
            sword.material = mat;
            swords.push(sword);
        }
        // 地面法阵
        this.createMagicCircle(pos, 5, c.main, 3.5);
        // 旋转动画 3秒
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            const t = elapsed / 1000;
            for (let i = 0; i < swordCount; i++) {
                const angle = (i / swordCount) * Math.PI * 2 + t * 4;
                const r = 3 + 0.5 * Math.sin(t * 3 + i);
                swords[i].position.x = pos.x + Math.cos(angle) * r;
                swords[i].position.z = pos.z + Math.sin(angle) * r;
                swords[i].position.y = pos.y + 1.0 + 0.3 * Math.sin(t * 5 + i * 0.8);
                swords[i].rotation.y = angle + Math.PI / 2;
                swords[i].rotation.z = Math.PI / 6;
            }
            if (elapsed >= 3000) {
                clearInterval(interval);
                // 向外爆散
                swords.forEach((s, i) => {
                    const outDir = new Vector3(s.position.x - pos.x, 0.5, s.position.z - pos.z).normalize();
                    let dt = 0;
                    const fly = setInterval(() => {
                        dt += 20;
                        s.position.addInPlace(outDir.scale(0.4));
                        s.material.alpha = 0.8 * (1 - dt / 400);
                        if (dt >= 400) {
                            clearInterval(fly);
                            s.dispose();
                        }
                    }, 20);
                });
            }
        }, 20);
        // 持续粒子
        this.aoeParticles(pos, 5, 3000, {
            tex: this.sparkTex,
            c1: c.c1, c2: c.c2, dead: c.dead,
            count: 300, life: 0.8, size: [0.05, 0.12],
            speed: [2, 5], gravity: -0.5, blend: 'add',
        });
        this.flashLight(pos, c.bright, 3, 6);
    }
    // 一剑寒光 — 直线剑光射线
    effectSwordBeam(pos, dir, c = this.getColors('sword')) {
        const d = dir ? dir.normalize() : Vector3.Forward();
        // 剑光射线（用 ShaderMaterial 做流动效果）
        const beam = MeshBuilder.CreatePlane('swordBeam', { width: 15, height: 0.6 }, this.scene);
        beam.position = pos.add(d.scale(7.5));
        beam.position.y += 1;
        beam.rotation.y = Math.atan2(d.x, d.z);
        beam.billboardMode = Mesh.BILLBOARDMODE_NONE;
        const mat = this.createShaderMat('swordQi', c.main, 0.9);
        beam.material = mat;
        // 沿路径的粒子
        for (let i = 0; i < 5; i++) {
            const p = pos.add(d.scale(i * 3));
            p.y += 1;
            this.burstParticles(p, {
                tex: this.sparkTex,
                c1: c.c1, c2: c.c2, dead: c.dead,
                count: 20, life: 0.3, size: [0.03, 0.08],
                speed: [3, 8], gravity: -2, blend: 'add',
            });
        }
        // 动画 + 淡出
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            mat.setFloat('time', elapsed / 1000);
            if (elapsed > 400) {
                mat.setFloat('alpha', 0.9 * (1 - (elapsed - 400) / 300));
            }
            if (elapsed >= 700) {
                clearInterval(interval);
                beam.dispose();
                mat.dispose();
            }
        }, 20);
        this.flashLight(pos.add(d.scale(3)), c.bright, 0.5, 5);
    }
    // 天罡剑阵 — 大范围阵法
    effectSwordUlt(pos, c = this.getColors('sword')) {
        // 大型法阵
        this.createMagicCircle(pos, 8, c.main, 5.5);
        // 8根剑柱从天而降
        for (let i = 0; i < 8; i++) {
            const angle = (i / 8) * Math.PI * 2;
            const px = pos.x + Math.cos(angle) * 6;
            const pz = pos.z + Math.sin(angle) * 6;
            setTimeout(() => {
                this.createSwordPillar(new Vector3(px, pos.y, pz), c, 5);
            }, i * 150);
        }
        // 大量粒子
        this.aoeParticles(pos, 8, 5000, {
            tex: this.particleTex,
            c1: c.c1, c2: c.c2, dead: c.dead,
            count: 500, life: 1.5, size: [0.08, 0.25],
            speed: [1, 4], gravity: 0, blend: 'add',
        });
        this.flashLight(pos, c.bright, 5, 8);
    }
    // 御剑护体 — 环绕护盾
    effectSwordShield(pos, c = this.getColors('sword')) {
        const shield = MeshBuilder.CreateSphere('swordShield', {
            diameter: 2.5, segments: 16
        }, this.scene);
        shield.position = pos.clone();
        shield.position.y += 1;
        const mat = this.createShaderMat('energyBall', c.main, 0.35);
        shield.material = mat;
        // 环绕小剑
        const blades = [];
        for (let i = 0; i < 4; i++) {
            const blade = MeshBuilder.CreateBox(`shieldBlade${i}`, {
                width: 0.05, height: 0.8, depth: 0.02
            }, this.scene);
            const bMat = new StandardMaterial(`bladeMat${i}`, this.scene);
            bMat.emissiveColor = c.bright;
            bMat.disableLighting = true;
            bMat.alpha = 0.7;
            blade.material = bMat;
            blades.push(blade);
        }
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            const t = elapsed / 1000;
            mat.setFloat('time', t);
            shield.position = pos.clone();
            shield.position.y = 1 + 0.1 * Math.sin(t * 3);
            // 护盾呼吸
            const s = 1 + 0.05 * Math.sin(t * 4);
            shield.scaling.setAll(s);
            for (let i = 0; i < 4; i++) {
                const angle = (i / 4) * Math.PI * 2 + t * 3;
                blades[i].position.x = pos.x + Math.cos(angle) * 1.5;
                blades[i].position.z = pos.z + Math.sin(angle) * 1.5;
                blades[i].position.y = pos.y + 1 + 0.2 * Math.sin(t * 5 + i);
                blades[i].rotation.y = angle;
            }
            if (elapsed >= 6000) {
                clearInterval(interval);
                this.fadeAndDispose(shield, mat, 0.5);
                blades.forEach(b => this.fadeAndDispose(b, b.material, 0.5));
            }
        }, 20);
    }
    // ==================== 道宗技能特效 ====================
    playDaoEffect(skill, pos, dir) {
        const c = this.getColors('dao');
        switch (skill.id) {
            case 'dao_basic':
                this.effectDaoFireball(pos, dir, c);
                break;
            case 'dao_thunder':
                this.effectDaoThunder(pos, c);
                break;
            case 'dao_blink':
                this.effectDaoBlink(pos, dir, c);
                break;
            case 'dao_buff':
                this.effectDaoBuff(pos, c);
                break;
            case 'dao_ult':
                this.effectDaoUlt(pos, c);
                break;
            case 'dao_pull':
                this.effectDaoPull(pos, dir, c);
                break;
        }
    }
    // 三昧真火 — 火球 + 燃烧轨迹
    effectDaoFireball(pos, dir, c = this.getColors('dao')) {
        const fireC1 = new Color4(1, 0.5, 0.1, 1);
        const fireC2 = new Color4(1, 0.2, 0, 0.6);
        const fireDead = new Color4(0.3, 0, 0, 0);
        const d = dir ? dir.normalize() : Vector3.Forward();
        // 火球本体
        const fireball = MeshBuilder.CreateSphere('fireball', { diameter: 0.6, segments: 8 }, this.scene);
        fireball.position = pos.add(new Vector3(0, 1, 0));
        const fbMat = this.createShaderMat('energyBall', new Color3(1, 0.4, 0.05), 0.8);
        fireball.material = fbMat;
        // 火焰粒子尾迹
        const firePs = new ParticleSystem('fireTail', 100, this.scene);
        firePs.particleTexture = this.particleTex;
        firePs.emitter = fireball;
        firePs.color1 = fireC1;
        firePs.color2 = fireC2;
        firePs.colorDead = fireDead;
        firePs.minSize = 0.1;
        firePs.maxSize = 0.3;
        firePs.minLifeTime = 0.2;
        firePs.maxLifeTime = 0.5;
        firePs.emitRate = 80;
        firePs.minEmitPower = 0.5;
        firePs.maxEmitPower = 1.5;
        firePs.createSphereEmitter(0.2);
        firePs.blendMode = ParticleSystem.BLENDMODE_ADD;
        firePs.gravity = new Vector3(0, 1, 0);
        firePs.start();
        // 火球飞行
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            fireball.position.addInPlace(d.scale(0.5));
            fbMat.setFloat('time', elapsed / 1000);
            if (elapsed >= 800) {
                clearInterval(interval);
                firePs.stop();
                // 命中爆炸
                this.burstParticles(fireball.position.clone(), {
                    tex: this.particleTex,
                    c1: fireC1, c2: fireC2, dead: fireDead,
                    count: 60, life: 0.6, size: [0.1, 0.35],
                    speed: [3, 8], gravity: -3, blend: 'add',
                });
                this.flashLight(fireball.position, new Color3(1, 0.5, 0.1), 0.4, 5);
                setTimeout(() => { firePs.dispose(); fireball.dispose(); fbMat.dispose(); }, 600);
            }
        }, 20);
    }
    // 雷霆万钧 — 天降雷柱 + 闪电分支
    effectDaoThunder(pos, c = this.getColors('dao')) {
        const thunderColor = new Color3(0.6, 0.6, 1.0);
        const thunderBright = new Color3(0.85, 0.85, 1.0);
        // 预警法阵
        this.createMagicCircle(pos, 5, thunderColor, 2);
        // 延迟后降下雷柱
        setTimeout(() => {
            // 主雷柱
            for (let i = 0; i < 3; i++) {
                setTimeout(() => {
                    const offset = new Vector3((Math.random() - 0.5) * 3, 0, (Math.random() - 0.5) * 3);
                    this.createLightningBolt(pos.add(offset), thunderColor, 12);
                }, i * 100);
            }
            // 雷电粒子爆发
            this.burstParticles(pos.add(new Vector3(0, 1, 0)), {
                tex: this.sparkTex,
                c1: new Color4(0.7, 0.7, 1, 1),
                c2: new Color4(0.4, 0.4, 0.9, 0.6),
                dead: new Color4(0.2, 0.2, 0.5, 0),
                count: 150, life: 0.6, size: [0.05, 0.15],
                speed: [5, 15], gravity: -3, blend: 'add',
            });
            // 地面冲击波
            this.createShockwave(pos, thunderColor, 5, 0.6);
            // 强闪光
            this.flashLight(pos, thunderBright, 0.5, 10);
        }, 500);
    }
    // 五行遁术 — 闪现 + 五行符文
    effectDaoBlink(pos, dir, c = this.getColors('dao')) {
        // 起始位置：紫色烟雾爆发
        this.burstParticles(pos.add(new Vector3(0, 1, 0)), {
            tex: this.smokeTex,
            c1: c.c1, c2: c.c2, dead: c.dead,
            count: 60, life: 0.8, size: [0.3, 0.8],
            speed: [2, 5], gravity: 0.5, blend: 'add',
        });
        // 五行符文闪烁
        const runeColors = [
            new Color3(0, 0.5, 0), // 木-绿
            new Color3(1, 0.2, 0), // 火-红
            new Color3(0.8, 0.7, 0), // 土-黄
            new Color3(0.8, 0.8, 0.9), // 金-白
            new Color3(0, 0.3, 0.8), // 水-蓝
        ];
        for (let i = 0; i < 5; i++) {
            const rune = MeshBuilder.CreatePlane(`rune${i}`, { size: 0.5 }, this.scene);
            const angle = (i / 5) * Math.PI * 2;
            rune.position = pos.add(new Vector3(Math.cos(angle) * 1.2, 1 + i * 0.3, Math.sin(angle) * 1.2));
            rune.billboardMode = Mesh.BILLBOARDMODE_ALL;
            const mat = new StandardMaterial(`runeMat${i}`, this.scene);
            mat.emissiveColor = runeColors[i];
            mat.disableLighting = true;
            mat.alpha = 0.8;
            mat.backFaceCulling = false;
            rune.material = mat;
            this.fadeAndDispose(rune, mat, 0.8);
        }
        this.flashLight(pos, c.bright, 0.3, 5);
    }
    // 紫气东来 — 紫气环绕 buff
    effectDaoBuff(pos, c = this.getColors('dao')) {
        // 紫色能量柱上升
        const pillar = MeshBuilder.CreateCylinder('daoBuffPillar', {
            height: 4, diameterTop: 0.5, diameterBottom: 2, tessellation: 12
        }, this.scene);
        pillar.position = pos.clone();
        pillar.position.y += 2;
        const mat = this.createShaderMat('energyBall', c.main, 0.5);
        pillar.material = mat;
        // 紫气粒子上升
        const ps = new ParticleSystem('daoBuffPs', 200, this.scene);
        ps.particleTexture = this.particleTex;
        ps.emitter = pos.clone();
        ps.emitter.y = pos.y + 0.5;
        ps.createCylinderEmitter(1, 0.5, 0, 0);
        ps.color1 = c.c1;
        ps.color2 = c.c2;
        ps.colorDead = c.dead;
        ps.minSize = 0.08;
        ps.maxSize = 0.2;
        ps.minLifeTime = 1;
        ps.maxLifeTime = 2;
        ps.emitRate = 100;
        ps.minEmitPower = 2;
        ps.maxEmitPower = 4;
        ps.gravity = new Vector3(0, 3, 0);
        ps.blendMode = ParticleSystem.BLENDMODE_ADD;
        ps.start();
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            mat.setFloat('time', elapsed / 1000);
            const prog = elapsed / 2000;
            if (prog > 0.7)
                mat.setFloat('alpha', 0.5 * (1 - (prog - 0.7) / 0.3));
            if (elapsed >= 2000) {
                clearInterval(interval);
                ps.stop();
                setTimeout(() => { ps.dispose(); pillar.dispose(); mat.dispose(); }, 2000);
            }
        }, 20);
        this.flashLight(pos, c.bright, 1.5, 5);
    }
    // 九天玄火阵 — 大范围火焰流星雨
    effectDaoUlt(pos, c = this.getColors('dao')) {
        const fireC1 = new Color4(1, 0.4, 0.1, 1);
        const fireC2 = new Color4(0.8, 0.1, 0.5, 0.7);
        // 大型法阵
        this.createMagicCircle(pos, 8, c.main, 4.5);
        // 流星雨：随机位置降落火球
        for (let i = 0; i < 15; i++) {
            setTimeout(() => {
                const rx = pos.x + (Math.random() - 0.5) * 14;
                const rz = pos.z + (Math.random() - 0.5) * 14;
                const meteorStart = new Vector3(rx + 5, 15, rz - 5);
                const meteorEnd = new Vector3(rx, 0, rz);
                const meteor = MeshBuilder.CreateSphere(`meteor${i}`, { diameter: 0.5, segments: 6 }, this.scene);
                meteor.position = meteorStart.clone();
                const mMat = new StandardMaterial(`meteorMat${i}`, this.scene);
                mMat.emissiveColor = new Color3(1, 0.4, 0.1);
                mMat.disableLighting = true;
                mMat.alpha = 0.9;
                meteor.material = mMat;
                // 尾焰
                const trail = new ParticleSystem(`meteorTrail${i}`, 30, this.scene);
                trail.particleTexture = this.particleTex;
                trail.emitter = meteor;
                trail.color1 = fireC1;
                trail.color2 = fireC2;
                trail.colorDead = new Color4(0.3, 0, 0, 0);
                trail.minSize = 0.1;
                trail.maxSize = 0.3;
                trail.minLifeTime = 0.1;
                trail.maxLifeTime = 0.3;
                trail.emitRate = 50;
                trail.minEmitPower = 0.5;
                trail.maxEmitPower = 1;
                trail.createSphereEmitter(0.1);
                trail.blendMode = ParticleSystem.BLENDMODE_ADD;
                trail.start();
                let t = 0;
                const fall = setInterval(() => {
                    t += 20;
                    const prog = t / 400;
                    meteor.position = Vector3.Lerp(meteorStart, meteorEnd, Math.min(prog, 1));
                    if (prog >= 1) {
                        clearInterval(fall);
                        trail.stop();
                        // 着地爆炸
                        this.burstParticles(meteorEnd.add(new Vector3(0, 0.5, 0)), {
                            tex: this.particleTex,
                            c1: fireC1, c2: fireC2, dead: new Color4(0.2, 0, 0, 0),
                            count: 30, life: 0.5, size: [0.1, 0.3],
                            speed: [3, 7], gravity: -4, blend: 'add',
                        });
                        this.flashLight(meteorEnd, new Color3(1, 0.4, 0.1), 0.3, 3);
                        setTimeout(() => { trail.dispose(); meteor.dispose(); }, 600);
                    }
                }, 20);
            }, Math.random() * 3500);
        }
        this.flashLight(pos, c.bright, 4, 8);
    }
    // 乾坤挪移 — 引力吸引效果
    effectDaoPull(pos, dir, c = this.getColors('dao')) {
        const target = dir ? pos.add(dir.normalize().scale(8)) : pos.add(Vector3.Forward().scale(8));
        // 引力光线
        const line = MeshBuilder.CreatePlane('pullBeam', { width: 12, height: 0.4 }, this.scene);
        line.position = Vector3.Lerp(pos, target, 0.5);
        line.position.y += 1;
        line.lookAt(target);
        line.billboardMode = Mesh.BILLBOARDMODE_NONE;
        const mat = this.createShaderMat('swordQi', c.main, 0.7);
        line.material = mat;
        // 目标位置漩涡粒子
        const vortex = new ParticleSystem('pullVortex', 100, this.scene);
        vortex.particleTexture = this.particleTex;
        vortex.emitter = target.clone();
        vortex.emitter.y = target.y + 1;
        vortex.createCylinderEmitter(2, 0, 0, 0);
        vortex.color1 = c.c1;
        vortex.color2 = c.c2;
        vortex.colorDead = c.dead;
        vortex.minSize = 0.05;
        vortex.maxSize = 0.15;
        vortex.minLifeTime = 0.3;
        vortex.maxLifeTime = 0.6;
        vortex.emitRate = 80;
        vortex.minEmitPower = 1;
        vortex.maxEmitPower = 3;
        vortex.gravity = new Vector3(0, -2, 0);
        vortex.blendMode = ParticleSystem.BLENDMODE_ADD;
        vortex.start();
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            mat.setFloat('time', elapsed / 1000);
            if (elapsed > 800)
                mat.setFloat('alpha', 0.7 * (1 - (elapsed - 800) / 400));
            if (elapsed >= 1200) {
                clearInterval(interval);
                vortex.stop();
                setTimeout(() => { vortex.dispose(); line.dispose(); mat.dispose(); }, 800);
            }
        }, 20);
        this.flashLight(target, c.bright, 0.5, 5);
    }
    // ==================== 少林技能特效 ====================
    playMonkEffect(skill, pos, dir) {
        const c = this.getColors('monk');
        switch (skill.id) {
            case 'monk_basic':
                this.effectMonkStrike(pos, dir, c);
                break;
            case 'monk_taunt':
                this.effectMonkTaunt(pos, c);
                break;
            case 'monk_heal':
                this.effectMonkHeal(pos, c);
                break;
            case 'monk_block':
                this.effectMonkBlock(pos, c);
                break;
            case 'monk_ult':
                this.effectMonkUlt(pos, c);
                break;
            case 'monk_invincible':
                this.effectMonkInvincible(pos, c);
                break;
        }
    }
    // 伏魔杖法 — 重击地面效果
    effectMonkStrike(pos, dir, c = this.getColors('monk')) {
        // 地面小冲击波
        this.createShockwave(pos, c.main, 2, 0.3);
        this.burstParticles(pos.add(new Vector3(0, 0.5, 0)), {
            tex: this.sparkTex,
            c1: c.c1, c2: c.c2, dead: c.dead,
            count: 25, life: 0.3, size: [0.05, 0.1],
            speed: [3, 7], gravity: -5, blend: 'add',
        });
        this.flashLight(pos, c.bright, 0.2, 3);
    }
    // 金刚怒目 — 嘲讽金光环
    effectMonkTaunt(pos, c = this.getColors('monk')) {
        // 金光冲击波向外扩散
        this.createShockwave(pos, c.main, 8, 0.8);
        // 环形怒目特效
        const ring = MeshBuilder.CreateTorus('tauntRing', {
            diameter: 3, thickness: 0.15, tessellation: 24
        }, this.scene);
        ring.position = pos.clone();
        ring.position.y += 1;
        const mat = new StandardMaterial('tauntMat', this.scene);
        mat.emissiveColor = c.bright;
        mat.disableLighting = true;
        mat.alpha = 0.8;
        mat.backFaceCulling = false;
        ring.material = mat;
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            const t = elapsed / 1000;
            const scale = 1 + t * 3;
            ring.scaling.setAll(scale);
            mat.alpha = 0.8 * (1 - t / 1.0);
            if (elapsed >= 1000) {
                clearInterval(interval);
                ring.dispose();
            }
        }, 20);
        // 金色粒子向外扩散
        this.aoeParticles(pos, 8, 1000, {
            tex: this.particleTex,
            c1: c.c1, c2: c.c2, dead: c.dead,
            count: 150, life: 0.8, size: [0.1, 0.3],
            speed: [5, 10], gravity: -1, blend: 'add',
        });
        this.flashLight(pos, c.bright, 0.8, 8);
    }
    // 大慈大悲 — 治疗金光
    effectMonkHeal(pos, c = this.getColors('monk')) {
        // 绿色 + 金色治疗光柱
        const healC1 = new Color4(0.3, 1, 0.5, 1);
        const healC2 = new Color4(0.8, 1, 0.4, 0.5);
        // 向上升腾的治疗粒子
        const ps = new ParticleSystem('healPs', 200, this.scene);
        ps.particleTexture = this.particleTex;
        ps.emitter = pos.clone();
        ps.createCylinderEmitter(5, 0.5, 0, 0);
        ps.color1 = healC1;
        ps.color2 = healC2;
        ps.colorDead = new Color4(0, 0.3, 0, 0);
        ps.minSize = 0.08;
        ps.maxSize = 0.2;
        ps.minLifeTime = 1;
        ps.maxLifeTime = 2;
        ps.emitRate = 100;
        ps.minEmitPower = 2;
        ps.maxEmitPower = 5;
        ps.gravity = new Vector3(0, 4, 0);
        ps.blendMode = ParticleSystem.BLENDMODE_ADD;
        ps.start();
        // 地面光圈
        this.createMagicCircle(pos, 10, new Color3(0.3, 0.8, 0.3), 2);
        setTimeout(() => {
            ps.stop();
            setTimeout(() => ps.dispose(), 2500);
        }, 1500);
        this.flashLight(pos, new Color3(0.3, 1, 0.5), 1.5, 5);
    }
    // 铜墙铁壁 — 格挡姿态
    effectMonkBlock(pos, c = this.getColors('monk')) {
        // 金色能量护盾（六面）
        const shield = MeshBuilder.CreateSphere('blockShield', {
            diameter: 2.2, segments: 6
        }, this.scene);
        shield.position = pos.clone();
        shield.position.y += 1;
        const mat = this.createShaderMat('energyBall', c.main, 0.3);
        shield.material = mat;
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            mat.setFloat('time', elapsed / 1000);
            shield.position = pos.clone();
            shield.position.y = 1;
            if (elapsed >= 4000) {
                clearInterval(interval);
                this.fadeAndDispose(shield, mat, 0.5);
            }
        }, 20);
    }
    // 降龙伏虎 — 跃起猛击地面
    effectMonkUlt(pos, c = this.getColors('monk')) {
        // 延迟模拟跳跃落地
        setTimeout(() => {
            // 大冲击波
            this.createShockwave(pos, c.main, 6, 1.0);
            // 地面裂纹效果（多条线段向外辐射）
            for (let i = 0; i < 8; i++) {
                const angle = (i / 8) * Math.PI * 2 + Math.random() * 0.3;
                const crack = MeshBuilder.CreatePlane(`crack${i}`, {
                    width: 4 + Math.random() * 2, height: 0.15
                }, this.scene);
                crack.position = pos.clone();
                crack.position.x += Math.cos(angle) * 2;
                crack.position.z += Math.sin(angle) * 2;
                crack.position.y = 0.08;
                crack.rotation.x = Math.PI / 2;
                crack.rotation.z = -angle;
                const cMat = new StandardMaterial(`crackMat${i}`, this.scene);
                cMat.emissiveColor = c.bright;
                cMat.disableLighting = true;
                cMat.alpha = 0.7;
                cMat.backFaceCulling = false;
                crack.material = cMat;
                this.fadeAndDispose(crack, cMat, 1.5);
            }
            // 碎石粒子
            this.burstParticles(pos.add(new Vector3(0, 0.5, 0)), {
                tex: this.sparkTex,
                c1: new Color4(0.6, 0.5, 0.3, 1),
                c2: c.c2,
                dead: new Color4(0.3, 0.2, 0.1, 0),
                count: 200, life: 1.0, size: [0.08, 0.25],
                speed: [5, 15], gravity: -10, blend: 'standard',
            });
            // 金光粒子
            this.burstParticles(pos.add(new Vector3(0, 0.5, 0)), {
                tex: this.particleTex,
                c1: c.c1, c2: c.c2, dead: c.dead,
                count: 100, life: 0.8, size: [0.1, 0.3],
                speed: [4, 10], gravity: -2, blend: 'add',
            });
            this.flashLight(pos, c.bright, 1, 10);
        }, 300);
    }
    // 般若金身 — 无敌金身
    effectMonkInvincible(pos, c = this.getColors('monk')) {
        // 金色佛像虚影
        const body = MeshBuilder.CreateCylinder('goldenBody', {
            height: 2.5, diameterTop: 0.8, diameterBottom: 1, tessellation: 8
        }, this.scene);
        body.position = pos.clone();
        body.position.y += 1.25;
        const mat = new StandardMaterial('goldenMat', this.scene);
        mat.emissiveColor = c.bright;
        mat.diffuseColor = c.main;
        mat.alpha = 0.5;
        mat.backFaceCulling = false;
        body.material = mat;
        // 光环
        const halo = MeshBuilder.CreateTorus('goldenHalo', {
            diameter: 1.5, thickness: 0.08, tessellation: 24
        }, this.scene);
        halo.position = pos.clone();
        halo.position.y += 2.5;
        halo.rotation.x = Math.PI / 6;
        const haloMat = new StandardMaterial('haloMat', this.scene);
        haloMat.emissiveColor = c.bright;
        haloMat.disableLighting = true;
        haloMat.alpha = 0.7;
        halo.material = haloMat;
        // 持续粒子
        const ps = new ParticleSystem('goldenPs', 150, this.scene);
        ps.particleTexture = this.sparkTex;
        ps.emitter = pos.clone();
        ps.emitter.y = pos.y + 1;
        ps.createSphereEmitter(1.5);
        ps.color1 = c.c1;
        ps.color2 = c.c2;
        ps.colorDead = c.dead;
        ps.minSize = 0.03;
        ps.maxSize = 0.1;
        ps.minLifeTime = 0.5;
        ps.maxLifeTime = 1.5;
        ps.emitRate = 60;
        ps.minEmitPower = 0.5;
        ps.maxEmitPower = 2;
        ps.gravity = new Vector3(0, 1, 0);
        ps.blendMode = ParticleSystem.BLENDMODE_ADD;
        ps.start();
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            const t = elapsed / 1000;
            body.position.y = pos.y + 1.25;
            const pulse = 1 + 0.05 * Math.sin(t * 6);
            body.scaling.setAll(pulse);
            halo.rotation.z += 0.02;
            if (elapsed >= 3000) {
                clearInterval(interval);
                ps.stop();
                this.fadeAndDispose(body, mat, 0.5);
                this.fadeAndDispose(halo, haloMat, 0.5);
                setTimeout(() => ps.dispose(), 2000);
            }
        }, 20);
        this.flashLight(pos, c.bright, 3, 5);
    }
    // ==================== 唐门技能特效 ====================
    playShadowEffect(skill, pos, dir) {
        const c = this.getColors('shadow');
        switch (skill.id) {
            case 'shadow_basic':
                this.effectShadowNeedle(pos, dir, c);
                break;
            case 'shadow_dash':
                this.effectShadowDash(pos, dir, c);
                break;
            case 'shadow_poison':
                this.effectShadowPoison(pos, dir, c);
                break;
            case 'shadow_assassinate':
                this.effectShadowAssassinate(pos, c);
                break;
            case 'shadow_ult':
                this.effectShadowUlt(pos, c);
                break;
            case 'shadow_decoy':
                this.effectShadowDecoy(pos, dir, c);
                break;
        }
    }
    // 暴雨梨花针 — 飞针弹幕
    effectShadowNeedle(pos, dir, c = this.getColors('shadow')) {
        const d = dir ? dir.normalize() : Vector3.Forward();
        // 多根飞针
        for (let i = 0; i < 5; i++) {
            setTimeout(() => {
                const needle = MeshBuilder.CreateCylinder(`needle${i}`, {
                    height: 0.5, diameterTop: 0, diameterBottom: 0.03, tessellation: 4
                }, this.scene);
                needle.position = pos.add(new Vector3(0, 1, 0));
                needle.position.x += (Math.random() - 0.5) * 0.5;
                needle.position.y += (Math.random() - 0.5) * 0.3;
                needle.lookAt(pos.add(d.scale(10)));
                needle.rotation.x += Math.PI / 2;
                const mat = new StandardMaterial(`needleMat${i}`, this.scene);
                mat.emissiveColor = new Color3(0.7, 0.7, 0.7);
                mat.disableLighting = true;
                needle.material = mat;
                // 飞行
                let t = 0;
                const fly = setInterval(() => {
                    t += 20;
                    needle.position.addInPlace(d.scale(0.8));
                    if (t >= 300) {
                        clearInterval(fly);
                        // 命中火花
                        this.burstParticles(needle.position.clone(), {
                            tex: this.sparkTex,
                            c1: new Color4(0.8, 0.8, 0.8, 1),
                            c2: c.c2,
                            dead: c.dead,
                            count: 8, life: 0.2, size: [0.02, 0.05],
                            speed: [3, 6], gravity: -5, blend: 'add',
                        });
                        needle.dispose();
                    }
                }, 20);
            }, i * 50);
        }
    }
    // 鬼影步 — 高速位移拖影
    effectShadowDash(pos, dir, c = this.getColors('shadow')) {
        // 暗绿色残影
        for (let i = 0; i < 4; i++) {
            const offset = dir ? dir.normalize().scale(-i * 2) : new Vector3(-i * 2, 0, 0);
            const ghost = MeshBuilder.CreateCylinder(`shadowGhost${i}`, {
                height: 1.8, diameter: 0.5, tessellation: 6
            }, this.scene);
            ghost.position = pos.add(offset);
            ghost.position.y += 0.9;
            const mat = new StandardMaterial(`shadowGhostMat${i}`, this.scene);
            mat.emissiveColor = c.main;
            mat.disableLighting = true;
            mat.alpha = 0.4 - i * 0.08;
            mat.backFaceCulling = false;
            ghost.material = mat;
            this.fadeAndDispose(ghost, mat, 0.3 + i * 0.1);
        }
        // 速度线粒子
        this.trailParticles(pos, dir || Vector3.Forward(), 8, {
            tex: this.sparkTex,
            c1: c.c1, c2: c.c2, dead: c.dead,
            count: 60, life: 0.4, size: [0.03, 0.08],
            speed: [1, 2], gravity: 0, blend: 'add',
        });
    }
    // 千蛛万毒 — 毒雾扩散
    effectShadowPoison(pos, dir, c = this.getColors('shadow')) {
        const poisonC1 = new Color4(0.1, 0.8, 0.2, 0.5);
        const poisonC2 = new Color4(0.05, 0.4, 0.1, 0.2);
        // 毒雾粒子（大而慢）
        const ps = new ParticleSystem('poisonCloud', 300, this.scene);
        ps.particleTexture = this.smokeTex;
        const d = dir ? dir.normalize() : Vector3.Forward();
        const emitPos = pos.add(d.scale(3));
        emitPos.y += 0.5;
        ps.emitter = emitPos;
        ps.createConeEmitter(2, Math.PI / 3);
        ps.color1 = poisonC1;
        ps.color2 = poisonC2;
        ps.colorDead = new Color4(0, 0.2, 0, 0);
        ps.minSize = 0.4;
        ps.maxSize = 1.2;
        ps.minLifeTime = 2;
        ps.maxLifeTime = 4;
        ps.emitRate = 60;
        ps.minEmitPower = 0.5;
        ps.maxEmitPower = 2;
        ps.gravity = new Vector3(0, 0.3, 0);
        ps.blendMode = ParticleSystem.BLENDMODE_ADD;
        ps.start();
        // 毒液飞溅小粒子
        this.burstParticles(emitPos, {
            tex: this.sparkTex,
            c1: new Color4(0.3, 1, 0.3, 1),
            c2: poisonC2,
            dead: new Color4(0, 0.1, 0, 0),
            count: 40, life: 0.5, size: [0.03, 0.08],
            speed: [3, 8], gravity: -5, blend: 'add',
        });
        setTimeout(() => {
            ps.stop();
            setTimeout(() => ps.dispose(), 5000);
        }, 2000);
        this.flashLight(emitPos, c.main, 1, 3);
    }
    // 影杀 — 隐身 + 致命一击
    effectShadowAssassinate(pos, c = this.getColors('shadow')) {
        // 隐身烟雾爆发
        this.burstParticles(pos.add(new Vector3(0, 1, 0)), {
            tex: this.smokeTex,
            c1: new Color4(0.2, 0.2, 0.2, 0.6),
            c2: new Color4(0.1, 0.1, 0.1, 0.3),
            dead: new Color4(0, 0, 0, 0),
            count: 50, life: 0.8, size: [0.3, 0.8],
            speed: [2, 5], gravity: 0.5, blend: 'standard',
        });
        // 暗影符号闪现
        const mark = MeshBuilder.CreatePlane('killMark', { size: 1.5 }, this.scene);
        mark.position = pos.clone();
        mark.position.y += 2;
        mark.billboardMode = Mesh.BILLBOARDMODE_ALL;
        const markMat = new StandardMaterial('killMarkMat', this.scene);
        markMat.emissiveColor = new Color3(1, 0.1, 0.1);
        markMat.disableLighting = true;
        markMat.alpha = 0.8;
        mark.material = markMat;
        // X 形标记用粒子
        this.burstParticles(pos.add(new Vector3(0, 2, 0)), {
            tex: this.sparkTex,
            c1: new Color4(1, 0.2, 0.2, 1),
            c2: c.c2,
            dead: new Color4(0.3, 0, 0, 0),
            count: 30, life: 0.5, size: [0.05, 0.12],
            speed: [2, 5], gravity: -1, blend: 'add',
        });
        this.fadeAndDispose(mark, markMat, 0.8);
        this.flashLight(pos, new Color3(0.8, 0.1, 0.1), 0.3, 4);
    }
    // 天女散花 — 空中暗器雨
    effectShadowUlt(pos, c = this.getColors('shadow')) {
        // 地面AOE指示
        this.createMagicCircle(pos, 8, c.main, 3.5);
        // 暗器从天而降
        for (let i = 0; i < 20; i++) {
            setTimeout(() => {
                const rx = pos.x + (Math.random() - 0.5) * 14;
                const rz = pos.z + (Math.random() - 0.5) * 14;
                const start = new Vector3(rx, 8, rz);
                const end = new Vector3(rx, 0, rz);
                const dart = MeshBuilder.CreateCylinder(`dart${i}`, {
                    height: 0.4, diameterTop: 0, diameterBottom: 0.04, tessellation: 4
                }, this.scene);
                dart.position = start.clone();
                dart.rotation.x = Math.PI;
                const dMat = new StandardMaterial(`dartMat${i}`, this.scene);
                dMat.emissiveColor = new Color3(0.6, 0.6, 0.6);
                dMat.disableLighting = true;
                dart.material = dMat;
                let t = 0;
                const fall = setInterval(() => {
                    t += 20;
                    dart.position = Vector3.Lerp(start, end, Math.min(t / 200, 1));
                    if (t >= 200) {
                        clearInterval(fall);
                        this.burstParticles(end.add(new Vector3(0, 0.3, 0)), {
                            tex: this.sparkTex,
                            c1: new Color4(0.7, 0.7, 0.7, 1),
                            c2: c.c2, dead: c.dead,
                            count: 10, life: 0.2, size: [0.02, 0.05],
                            speed: [2, 5], gravity: -5, blend: 'add',
                        });
                        dart.dispose();
                    }
                }, 20);
            }, Math.random() * 2800);
        }
        // 持续闪烁光效
        for (let i = 0; i < 6; i++) {
            setTimeout(() => {
                const rp = pos.add(new Vector3((Math.random() - 0.5) * 12, 0, (Math.random() - 0.5) * 12));
                this.flashLight(rp, c.bright, 0.2, 3);
            }, i * 500);
        }
    }
    // 移形换影 — 残影爆炸
    effectShadowDecoy(pos, dir, c = this.getColors('shadow')) {
        // 残影本体
        const decoy = MeshBuilder.CreateCylinder('decoy', {
            height: 1.8, diameter: 0.5, tessellation: 6
        }, this.scene);
        decoy.position = pos.clone();
        decoy.position.y += 0.9;
        const mat = new StandardMaterial('decoyMat', this.scene);
        mat.emissiveColor = c.main;
        mat.disableLighting = true;
        mat.alpha = 0.6;
        mat.backFaceCulling = false;
        decoy.material = mat;
        // 残影闪烁后爆炸
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            const t = elapsed / 1000;
            mat.alpha = 0.6 * (0.5 + 0.5 * Math.sin(t * 15));
            if (elapsed >= 1500) {
                clearInterval(interval);
                // 爆炸
                this.burstParticles(decoy.position.clone(), {
                    tex: this.particleTex,
                    c1: c.c1, c2: c.c2, dead: c.dead,
                    count: 100, life: 0.6, size: [0.1, 0.3],
                    speed: [5, 12], gravity: -3, blend: 'add',
                });
                this.createShockwave(pos, c.main, 3, 0.5);
                this.flashLight(pos, c.bright, 0.4, 6);
                decoy.dispose();
            }
        }, 20);
    }
    // ==================== 公共特效构件 ====================
    // 创建 ShaderMaterial（带 time 动画）
    createShaderMat(shaderName, color, alpha) {
        const mat = new ShaderMaterial(`${shaderName}Mat_${Date.now()}`, this.scene, shaderName, {
            attributes: ['position', 'normal', 'uv'],
            uniforms: ['worldViewProjection', 'time', 'baseColor', 'alpha'],
        });
        mat.setFloat('time', 0);
        mat.setColor3('baseColor', color);
        mat.setFloat('alpha', alpha);
        mat.backFaceCulling = false;
        mat.alphaMode = 2; // ALPHA_COMBINE
        mat.alpha = 0.99; // 启用透明排序
        return mat;
    }
    // 剑气弧线（ShaderMaterial 版本）
    createSwordQiArc(pos, color, size) {
        const arc = MeshBuilder.CreatePlane('swordQiArc', { width: size * 2, height: size * 0.6 }, this.scene);
        arc.position = pos.clone();
        arc.position.y += 1;
        arc.billboardMode = Mesh.BILLBOARDMODE_NONE;
        arc.rotation.x = Math.PI / 4;
        arc.rotation.y = Math.random() * Math.PI * 2;
        const mat = this.createShaderMat('swordQi', color, 0.9);
        arc.material = mat;
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            const t = elapsed / 1000;
            mat.setFloat('time', t);
            const scale = 1 + t * 2;
            arc.scaling.x = scale;
            arc.scaling.y = scale * 0.8;
            if (elapsed > 200)
                mat.setFloat('alpha', 0.9 * (1 - (elapsed - 200) / 300));
            if (elapsed >= 500) {
                clearInterval(interval);
                arc.dispose();
                mat.dispose();
            }
        }, 20);
        return arc;
    }
    // 地面法阵（ShaderMaterial）
    createMagicCircle(pos, radius, color, duration) {
        const circle = MeshBuilder.CreateDisc('magicCircle', {
            radius, tessellation: 48
        }, this.scene);
        circle.position = pos.clone();
        circle.position.y = 0.06;
        circle.rotation.x = Math.PI / 2;
        const mat = this.createShaderMat('magicCircle', color, 0.6);
        circle.material = mat;
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            mat.setFloat('time', elapsed / 1000);
            // 最后20%淡出
            const prog = elapsed / (duration * 1000);
            if (prog > 0.8) {
                mat.setFloat('alpha', 0.6 * (1 - (prog - 0.8) / 0.2));
            }
            if (elapsed >= duration * 1000) {
                clearInterval(interval);
                circle.dispose();
                mat.dispose();
            }
        }, 20);
    }
    // 雷电柱（ShaderMaterial + 随机分支）
    createLightningBolt(pos, color, height) {
        // 主干
        const bolt = MeshBuilder.CreatePlane('lightning', {
            width: 0.8, height
        }, this.scene);
        bolt.position = pos.clone();
        bolt.position.y += height / 2;
        bolt.billboardMode = Mesh.BILLBOARDMODE_Y;
        const mat = this.createShaderMat('lightning', color, 0.9);
        bolt.material = mat;
        // 分支（2-3条小闪电）
        const branches = [];
        const branchCount = 2 + Math.floor(Math.random() * 2);
        for (let i = 0; i < branchCount; i++) {
            const branch = MeshBuilder.CreatePlane(`lBranch${i}`, {
                width: 0.4, height: height * 0.4
            }, this.scene);
            branch.position = pos.clone();
            branch.position.y += height * (0.3 + Math.random() * 0.4);
            branch.position.x += (Math.random() - 0.5) * 2;
            branch.position.z += (Math.random() - 0.5) * 2;
            branch.rotation.z = (Math.random() - 0.5) * 1.2;
            branch.billboardMode = Mesh.BILLBOARDMODE_Y;
            const bMat = this.createShaderMat('lightning', color, 0.6);
            branch.material = bMat;
            branches.push(branch);
        }
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            mat.setFloat('time', elapsed / 1000);
            branches.forEach(b => {
                b.material.setFloat('time', elapsed / 1000);
            });
            if (elapsed > 300) {
                const fade = 0.9 * (1 - (elapsed - 300) / 300);
                mat.setFloat('alpha', fade);
                branches.forEach(b => b.material.setFloat('alpha', fade * 0.7));
            }
            if (elapsed >= 600) {
                clearInterval(interval);
                bolt.dispose();
                mat.dispose();
                branches.forEach(b => { b.dispose(); b.material.dispose(); });
            }
        }, 20);
    }
    // 冲击波环（快速扩散的圆环）
    createShockwave(pos, color, maxRadius, duration) {
        const ring = MeshBuilder.CreateTorus('shockwave', {
            diameter: 1, thickness: 0.15, tessellation: 32
        }, this.scene);
        ring.position = pos.clone();
        ring.position.y = 0.1;
        const mat = new StandardMaterial('shockwaveMat', this.scene);
        mat.emissiveColor = color;
        mat.disableLighting = true;
        mat.alpha = 0.7;
        mat.backFaceCulling = false;
        ring.material = mat;
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 20;
            const prog = elapsed / (duration * 1000);
            const scale = 1 + prog * maxRadius;
            ring.scaling.x = scale;
            ring.scaling.z = scale;
            ring.scaling.y = Math.max(0.3, 1 - prog * 0.7);
            mat.alpha = 0.7 * (1 - prog);
            if (prog >= 1) {
                clearInterval(interval);
                ring.dispose();
            }
        }, 20);
    }
    // 从天而降的剑柱
    createSwordPillar(pos, c, duration) {
        const sword = MeshBuilder.CreateBox('swordPillar', {
            width: 0.1, height: 2.5, depth: 0.03
        }, this.scene);
        // 从天上落下
        sword.position = pos.clone();
        sword.position.y = 10;
        const mat = new StandardMaterial('swordPillarMat', this.scene);
        mat.emissiveColor = c.bright;
        mat.disableLighting = true;
        mat.alpha = 0.8;
        mat.backFaceCulling = false;
        sword.material = mat;
        let elapsed = 0;
        const fallTime = 200;
        const interval = setInterval(() => {
            elapsed += 20;
            if (elapsed <= fallTime) {
                // 下落
                const prog = elapsed / fallTime;
                sword.position.y = 10 - prog * 10;
            }
            else {
                // 插在地上发光
                sword.position.y = 0 + 1.25;
                const t = (elapsed - fallTime) / 1000;
                const pulse = 0.8 + 0.2 * Math.sin(t * 8);
                mat.alpha = pulse * (1 - (elapsed - fallTime) / (duration * 1000));
            }
            if (elapsed >= fallTime + duration * 1000) {
                clearInterval(interval);
                sword.dispose();
            }
        }, 20);
        // 落地时的粒子
        setTimeout(() => {
            this.burstParticles(pos.add(new Vector3(0, 0.5, 0)), {
                tex: this.sparkTex,
                c1: c.c1, c2: c.c2, dead: c.dead,
                count: 20, life: 0.4, size: [0.03, 0.08],
                speed: [3, 6], gravity: -3, blend: 'add',
            });
        }, fallTime);
    }
    // 粒子爆发（一次性）
    burstParticles(pos, opts) {
        const ps = new ParticleSystem(`burst_${Date.now()}`, opts.count, this.scene);
        ps.particleTexture = opts.tex;
        ps.emitter = pos;
        ps.createSphereEmitter(0.3);
        ps.color1 = opts.c1;
        ps.color2 = opts.c2;
        ps.colorDead = opts.dead;
        ps.minSize = opts.size[0];
        ps.maxSize = opts.size[1];
        ps.minLifeTime = opts.life * 0.5;
        ps.maxLifeTime = opts.life;
        ps.emitRate = opts.count * 5;
        ps.minEmitPower = opts.speed[0];
        ps.maxEmitPower = opts.speed[1];
        ps.gravity = new Vector3(0, opts.gravity, 0);
        ps.blendMode = opts.blend === 'add' ? ParticleSystem.BLENDMODE_ADD : ParticleSystem.BLENDMODE_STANDARD;
        // 一次性爆发
        ps.manualEmitCount = opts.count;
        ps.start();
        setTimeout(() => {
            ps.stop();
            setTimeout(() => ps.dispose(), (opts.life + 0.5) * 1000);
        }, 100);
    }
    // AOE 区域持续粒子
    aoeParticles(pos, radius, duration, opts) {
        const ps = new ParticleSystem(`aoe_${Date.now()}`, opts.count, this.scene);
        ps.particleTexture = opts.tex;
        ps.emitter = pos.clone();
        ps.createCylinderEmitter(radius, 0.5, 0, 0);
        ps.color1 = opts.c1;
        ps.color2 = opts.c2;
        ps.colorDead = opts.dead;
        ps.minSize = opts.size[0];
        ps.maxSize = opts.size[1];
        ps.minLifeTime = opts.life * 0.5;
        ps.maxLifeTime = opts.life;
        ps.emitRate = opts.count / Math.max(0.5, opts.life);
        ps.minEmitPower = opts.speed[0];
        ps.maxEmitPower = opts.speed[1];
        ps.gravity = new Vector3(0, opts.gravity, 0);
        ps.blendMode = opts.blend === 'add' ? ParticleSystem.BLENDMODE_ADD : ParticleSystem.BLENDMODE_STANDARD;
        ps.start();
        setTimeout(() => {
            ps.stop();
            setTimeout(() => ps.dispose(), (opts.life + 1) * 1000);
        }, duration);
    }
    // 轨迹粒子（沿方向散布）
    trailParticles(pos, dir, length, opts) {
        const d = dir.normalize();
        const stepCount = 5;
        for (let i = 0; i < stepCount; i++) {
            const p = pos.add(d.scale((i / stepCount) * length));
            p.y += 0.5;
            setTimeout(() => {
                this.burstParticles(p, {
                    ...opts,
                    count: Math.floor(opts.count / stepCount),
                });
            }, i * 50);
        }
    }
    // 点光源闪光
    flashLight(pos, color, duration, intensity) {
        const light = new PointLight(`flash_${Date.now()}`, pos.add(new Vector3(0, 1.5, 0)), this.scene);
        light.diffuse = color;
        light.specular = color;
        light.intensity = intensity;
        light.range = 15;
        let elapsed = 0;
        const interval = setInterval(() => {
            elapsed += 30;
            const prog = elapsed / (duration * 1000);
            light.intensity = intensity * (1 - prog);
            if (prog >= 1) {
                clearInterval(interval);
                light.dispose();
            }
        }, 30);
    }
    // 网格淡出并销毁
    fadeAndDispose(mesh, material, duration) {
        let elapsed = 0;
        const startAlpha = material instanceof StandardMaterial ? material.alpha : 1;
        const interval = setInterval(() => {
            elapsed += 20;
            const prog = elapsed / (duration * 1000);
            if (material instanceof StandardMaterial) {
                material.alpha = startAlpha * (1 - prog);
            }
            else {
                material.setFloat('alpha', startAlpha * (1 - prog));
            }
            if (prog >= 1) {
                clearInterval(interval);
                mesh.dispose();
                material.dispose();
            }
        }, 20);
    }
}
